// Generated by BUCKLESCRIPT VERSION 3.0.0, PLEASE EDIT WITH CARE
'use strict';

var ClassNames = require("./ClassNames.bs.js");

var make = ClassNames.make;

var ifBool = ClassNames.ifBool;

var ifOpt = ClassNames.ifOpt;

var mapOpt = ClassNames.mapOpt;

exports.make = make;
exports.ifBool = ifBool;
exports.ifOpt = ifOpt;
exports.mapOpt = mapOpt;
/* No side effect */



//////////////////
// WEBPACK FOOTER
// ./~/re-classnames/src/Cn.bs.js
// module id = 554
// module chunks = 114276838955818